const W_BASE_PREFIX = "/aa/WPortalapiV1";

export const CONSENT_ENDPOINTS = {
    HANDLE: `${W_BASE_PREFIX}/GETCONSENTHANDLEDETAILS_V1`,
    SUBMIT: `${W_BASE_PREFIX}/ConsentArtefact_v1`,
    REJECT: `${W_BASE_PREFIX}/ConsentRejection`,
    LIST: `${W_BASE_PREFIX}/GETCONSENTLIST_V1`, // Added for dashboard
    
    // Self Consent Endpoints
    SELF_CONSENT_DEFAULT: `${W_BASE_PREFIX}/GETSELFCONSENTDEFAULT`,
    SELF_CONSENT: `${W_BASE_PREFIX}/SELFCONSENT`,
    CONSENT_STATUS: `${W_BASE_PREFIX}/CONSENTWITHSTATUS`,
};

export const AUTH_ENDPOINTS = {
    TRIGGER_OTP: `${W_BASE_PREFIX}/TRIGGEROTP`,
    VERIFY_OTP: `${W_BASE_PREFIX}/MFA_VERIFYOTP`,
    LOGIN: `${W_BASE_PREFIX}/LOGIN`,
    SET_PIN: `${W_BASE_PREFIX}/SETMPIN`,
    LOGOUT: `${W_BASE_PREFIX}/WLOGOUT`,
};

export const ACCOUNT_ENDPOINTS = {
    DISCOVER: `${W_BASE_PREFIX}/Discover_V2`,
    GET_IDENTIFIERS: `${W_BASE_PREFIX}/GetIdentifierstype`,
    LINK: `${W_BASE_PREFIX}/Link`,
    VERIFY_LINK: `${W_BASE_PREFIX}/AuthenticateToken`,
    LINK_DESC: `${W_BASE_PREFIX}/LINKDESC_V1`,
    LINK_STATUS: `${W_BASE_PREFIX}/LINKSTATUS`,
};

export const FIP_ENDPOINTS = {
    CATEGORIES: `${W_BASE_PREFIX}/GETASSETCLASS`,
    SEARCH: `${W_BASE_PREFIX}/SearchFIP`,
    RECENTLY_SEARCH_FIP: `${W_BASE_PREFIX}/RECENTLYSEARCHFIP`,
};

export const SECONDARY_ENDPOINTS = {
    LIST: `${W_BASE_PREFIX}/GETMOBILENUMBERS`,
    ADD: `${W_BASE_PREFIX}/GENERATEOTP`,
    VERIFY: `${W_BASE_PREFIX}/ADDNEWMOBILE`,
};

export const AA_ENDPOINTS = {
    CONSENT: "/Consent",
    FI_REQUEST: "/FI/request",
    FI_FETCH: "/FI/fetch",
    CONSENT_NOTIFICATION: "/Consent/Notification",
};
